import React from "react";
import classNames from "classnames";

import styles from "./Section.module.scss";

const Section = ({ className, children }) => {
  return (
    <section className={classNames(styles.Section, className)}>
      <div className="wrap holder no-pdn-top">
        {children}
      </div>
    </section>
  )
}

export default Section;
